import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { JobCreationProvider } from "../Pages/JobCreationContext";
import StepSidebar from "./StepSide-bar";
import "./CreateJobLayout.css";
import ArrowLeft from "../../../asset/svgs/ArrowLeft";

const stepPathMap = {
  1: "/jobs/job-admin/job-posts/create-job",
  2: "/jobs/job-admin/job-posts/create-job/compensation",
  3: "/jobs/job-admin/job-posts/create-job/description",
  4: "/jobs/job-admin/job-posts/create-job/media&finalize",
};

export default function CreateJobLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const currentStep =
    Object.entries(stepPathMap).find(
      ([, path]) => path === location.pathname
    )?.[0] || "1";

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <JobCreationProvider>
      <div className="create-job-layout-wrapper">
        <div className="header-with-back" style={{ marginBottom: "1rem" }}>
          <button onClick={handleBack} className="back-button">
            <ArrowLeft size={20} />
          </button>
          <h1 className="header-title">Job Post</h1>
        </div>
        <div className="create-job-layout">
          <StepSidebar currentStep={currentStep} />
          <div className="create-job-content">
            <Outlet />
          </div>
        </div>
      </div>
    </JobCreationProvider>
  );
}
